/**
 * returns element, which should be used as a root for portal to display elements in overlay
 * @param rootRef
 * @param fallbackId
 */
export function getPortalRootElement(rootRef: React.RefObject<HTMLDivElement>, fallbackId = "autocomplete-root"): HTMLDivElement | null {
    return rootRef?.current ?? (document.getElementById(fallbackId) as HTMLDivElement);
}